import { COUNT_DIGITS } from "../../../analytics/constants";

export const calcEtsyMarketplaceFees = (soldPrice, shippingCost) => {
  const ETSY_FEES_VALUE_PERCENT = 0.05;
  const etsyFees = (+soldPrice + +shippingCost) * ETSY_FEES_VALUE_PERCENT;
  return etsyFees.toFixed(COUNT_DIGITS);
};
